// extracted by mini-css-extract-plugin
export default {"accordion_root":"v9","accordion_summary":"w9","accordion_details_root":"x9","expand_icon":"y9","rotate_arrow":"z9","info_item":"A9","ingredient":"B9","title":"C9","product":"E9","img":"F9"};
    if(module.hot) {
      // 1714654900294
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  